import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from "reactstrap";
import avatar1 from "../../assets/images/users/avatar-1.jpg";
import { createSelector } from "reselect";
import {
  clearSessionStorage,
  setItem,
  getItem,
} from "Components/constants/SessionStores";
import { toast } from "react-toastify";
import {
  altImageText,
  checkStatusCodeSuccess,
  LogoutMessage,
} from "Components/constants/Common";
import { viewProfile } from "Api/UserApi";
import { BaseImageURL } from "Api/services";
import BaseModal from "Components/Base/BaseModal";
import { NoLabel, YesLabel } from "Components/constants/Role";

const ProfileDropdown = () => {
  const dispatch = useDispatch();
  const userImage = useSelector((state: any) => state.Profile.user);
  const profiledropdownData = createSelector(
    (state: any) => state.Profile.user,
    (user) => user
  );
  const user = useSelector(profiledropdownData);
  const [logOutModal, setLogOutModal] = useState<boolean>(false);

  const [userName, setUserName] = useState("Admin");
  const [isProfileDropdown, setIsProfileDropdown] = useState<boolean>(false);
  const [Loader, setLoader] = useState<boolean>(false);
  const [profileData, setProfileData] = useState([]);
  const [profileImage, setProfileImage] = useState<string | null>(null);
  const [Name, setName] = useState<string | null>(null);
  const [Role, setRole] = useState<string | null>(null);

  useEffect(() => {
    const storedProfile = getItem("userProfile");
    if (storedProfile) {
      const profileData = JSON.parse(storedProfile);
      setProfileImage(profileData.profile_image);
      setName(profileData.name);
      setRole(profileData.position?.role);
    }

    viewProfileData();
  }, []);

  useEffect(() => {
    if (user?.profile_image) {
      setProfileImage(user.profile_image);
    }
    if (user?.name) {
      setName(user.name);
    }
    if (user?.position?.role) {
      setRole(user.position.role);
    }
  }, [user]);

  const viewProfileData = () => {
    setLoader(true);
    viewProfile()
      .then((res) => {
        if (checkStatusCodeSuccess(res?.statusCode)) {
          setProfileData(res?.data);
          setProfileImage(res?.data.profile_image);
          setRole(res?.data.position.role);
          setName(res?.data.name);
          setItem("userProfile", JSON.stringify(res?.data));
        } else {
          toast.error(res?.message);
        }
      })
      .catch((error) => {
        return error;
      })
      .finally(() => setLoader(false));
  };

  const toggleProfileDropdown = () => {
    setIsProfileDropdown(!isProfileDropdown);
  };

  return (
    <React.Fragment>
      <Dropdown
        isOpen={isProfileDropdown}
        toggle={toggleProfileDropdown}
        className="ms-sm-3 header-item topbar-user"
      >
        <DropdownToggle tag="button" type="button" className="btn shadow-none">
          <span className="d-flex align-items-center">
            <img
              className="rounded-md header-profile-user"
              src={profileImage ? `${BaseImageURL}${profileImage}` : avatar1}
              alt={altImageText}
              onError={(e) => {
                const target = e.target as HTMLImageElement;
                target.onerror = null;
                target.src = avatar1;
              }}
            />
            <span className="text-start ms-xl-2">
              <span className="d-none d-xl-inline-block ms-1 fw-medium user-name-text">
                {Name}
              </span>
              <span className="d-none d-xl-block ms-1 fs-12 text-muted user-name-sub-text">
                {Role}
              </span>
            </span>
          </span>
        </DropdownToggle>
        <DropdownMenu className="dropdown-menu-end">
          <h6 className="dropdown-header">Welcome {Name}!</h6>
          <DropdownItem href="/profile">
            <i className="mdi mdi-account-circle text-muted fs-16 align-middle me-1"></i>{" "}
            <span className="align-middle">Profile</span>
          </DropdownItem>
          <DropdownItem href="/change-password">
            <i className="mdi mdi-lock text-muted fs-16 align-middle me-1"></i>{" "}
            <span className="align-middle">Change Password</span>
          </DropdownItem>
          <div className="dropdown-divider"></div>{" "}
          <DropdownItem onClick={() => setLogOutModal(true)}>
            <i className="mdi mdi-logout text-muted fs-16 align-middle me-1"></i>{" "}
            <span className="align-middle" data-key="t-logout">
              Logout
            </span>
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>
      <BaseModal
        open={logOutModal}
        toggle={() => {
          setLogOutModal(false);
        }}
        title={"Logout"}
        closeLabel={NoLabel}
        submitLabel={YesLabel}
        closeLabelColor="danger"
        submitLabelColor="success"
        loader={Loader}
        size="sm"
        submit={() => {
          setLoader(true);
          clearSessionStorage();
          setTimeout(() => {
            setLoader(false);
            window.location.href = "/logout";
          }, 1500);
        }}
      >
        <div className="form-group">
          <p>{LogoutMessage}</p>
        </div>
      </BaseModal>
    </React.Fragment>
  );
};

export default ProfileDropdown;
